import { PublicKey } from "@solana/web3.js";
export const PROGRAM_ID = new PublicKey("aucwFHspXAnpzCcgCDnepFisGixxxEhW4rkBVizjXcg");
//# sourceMappingURL=constants.js.map